"use client";

import { useSearchParams } from "next/navigation";
import { ErrorMessage } from "@/components/ErrorMessage";
import { useSignUp } from "@/contexts/signup";
import { useTranslations } from "next-intl";
type SignInError = "Verification" | "Configuration" | "AccessDenied" | "NotSignedIn" | "default_error";
const getSigninErrorMessage = (error: SignInError) => {
  switch (error) {
    case "Verification":
      return "verification_error";
    case "Configuration":
      return "configuration_error";
    case "AccessDenied":
      return "access_denied_error";
    case "NotSignedIn":
      return "not_signed_in_error";
    default:
      return "default_error";
  }
};
const SignInErrorMessage = () => {
  const t = useTranslations("signup_form");
  const searchParams = useSearchParams();
  const {
    state
  } = useSignUp();
  const signInError = searchParams.get("error") as SignInError;
  const validationError = state.error;
  return <>
      {signInError && <ErrorMessage className="my-4" message={t(getSigninErrorMessage(signInError))} />}
      {validationError && <ErrorMessage className="my-4" message={t(validationError.message)} />}
    </>;
};
export { SignInErrorMessage };